"use client";
import { jsx } from "react/jsx-runtime";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { Avatar as Avatar$1 } from "@mantine/core";
import { forwardRef } from "react";
import '../../../assets/Avatar.css';const root = "_root_jf3fs_2";
const AvatarStyles = {
  root
};
const _Avatar = forwardRef((props, ref) => {
  const { size = "xl", src, ...rest } = props;
  const multiple = Array.isArray(src);
  return multiple ? /* @__PURE__ */ jsx(Avatar$1.Group, { ...rest, ref, children: src.map((item, index) => /* @__PURE__ */ jsx(
    Avatar$1,
    {
      radius: "xl",
      size,
      classNames: AvatarStyles,
      src: item.src,
      alt: item.alt
    },
    `${item == null ? void 0 : item.src}-${item == null ? void 0 : item.alt}-${index}`
  )) }) : /* @__PURE__ */ jsx(
    Avatar$1,
    {
      ...rest,
      ref,
      radius: "xl",
      src: src.src,
      alt: src.alt,
      size,
      classNames: AvatarStyles
    }
  );
});
_Avatar.displayName = "Avatar";
const Avatar = sharedHandler(_Avatar);
Avatar.displayName = _Avatar.displayName;
export {
  AvatarStyles as A,
  Avatar as default
};
